module.exports = __webpack_public_path__ + "img/f897053642d8e357782982d9b9a7b8c6.png";